import { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalForm from "./ModalForm";
import CustomButton from "@/common/customElements/button";
import { CustomDiv, InlineDiv } from "@/common/divs";
import { AlmostBoldText, RegularText } from "@/common/texts";
import GoogleTranslationComponent from "@/components/googleTranslate/GoogleTranslationComponent";
import {
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";

export const EmbeddedForm = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <InlineDiv className="inputNewsletter">
        <CustomDiv
          style={{ height: "50px", alignContent: "center" }}
          className="inputNewsletterEmail"
          width="65%"
          height="50px"
          marginY="16px"
        >
          <AlmostBoldText
            style={{ marginLeft: "2px" }}
            color={SECONDARY_BUTTON_COLOR}
            fontSize="18px"
          >
            <GoogleTranslationComponent
              text={"¡Suscribete ahora y recibe un cupón del 10% de descuento!"}
            />
          </AlmostBoldText>
        </CustomDiv>

        <button
          onClick={(e) => {
            e.preventDefault();
            setOpen(true);
          }}
        >
          <CustomButton
            toBeResponsive={true}
            width="197px"
            height="50px"
            marginY="16px"
            marginLeft="16px"
            backgroundColor={PRIMARY_BUTTON_COLOR}
          >
            <RegularText fontSize="18px" color={NEUTRO_TITLES_COLOR}>
              {t("footer.suscribe_button")}
            </RegularText>
          </CustomButton>
        </button>
      </InlineDiv>
      {open && <ModalForm open={open} setOpen={setOpen} />}
    </>
  );
};
